import { render } from "./McpGuidePage.vue?vue&type=template&id=2dd343c2&scoped=true"
import script from "./McpGuidePage.vue?vue&type=script&lang=js"
export * from "./McpGuidePage.vue?vue&type=script&lang=js"

import "./McpGuidePage.vue?vue&type=style&index=0&id=2dd343c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd343c2"]])

export default __exports__